'use client';

import { useState } from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { reminderSettings } from '@/features/admin/presentation/data/mockData';
import { Button } from '@/core/presentation/components/ui/Button';
import { Input } from '@/core/presentation/components/ui/Input';
import { Label } from '@/core/presentation/components/ui/Label';
import { Switch } from '@/core/presentation/components/ui/Switch';
import { Save, RotateCcw } from 'lucide-react';
import { useToast } from '@/core/presentation/components/Toast';

export default function ReminderSettingsPage() {
  const toast = useToast();
  const [settings] = useState(reminderSettings);
  const [channels, setChannels] = useState({ email: true, whatsapp: true, push: false });

  const handleSave = () => {
    toast.success('Configurações salvas. As alterações foram aplicadas com sucesso.');
  };

  return (
    <div>
      <SectionHeader
        title="Configurações de Lembrete"
        subtitle="Defina regras e comportamentos dos lembretes automáticos"
        actions={
          <div className="flex gap-2">
            <Button variant="outline" className="border-admin-border text-admin-text">
              <RotateCcw className="h-4 w-4 mr-1" />
              Resetar
            </Button>
            <Button className="bg-admin-navy hover:bg-admin-navy-mid text-white" onClick={handleSave}>
              <Save className="h-4 w-4 mr-1" />
              Salvar
            </Button>
          </div>
        }
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Canais de envio</h3>
          <div className="space-y-4">
            {(['email', 'whatsapp', 'push'] as const).map((ch) => (
              <div key={ch} className="flex items-center justify-between p-3 rounded-lg bg-admin-bg-block">
                <Label className="text-sm text-admin-text capitalize cursor-pointer">{ch}</Label>
                <Switch
                  checked={channels[ch]}
                  onCheckedChange={(v) => setChannels((prev) => ({ ...prev, [ch]: v }))}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Intervalos de lembrete (dias)</h3>
          <div className="flex flex-wrap gap-2 mb-4">
            {settings.intervals.map((interval) => (
              <span
                key={interval}
                className="px-3 py-1.5 rounded-lg bg-admin-cyan-light/30 text-admin-navy text-sm font-medium"
              >
                {interval}d
              </span>
            ))}
          </div>
          <Button variant="outline" size="sm" className="border-admin-border text-admin-text">
            + Adicionar intervalo
          </Button>
        </div>

        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Tentativas de reenvio</h3>
          <div className="space-y-3">
            <div>
              <Label className="text-xs text-admin-text-secondary">Máximo de tentativas</Label>
              <Input type="number" defaultValue={settings.maxRetries} className="mt-1 border-admin-border" variant="light" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-admin-border p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-admin-text mb-4">Horário silencioso</h3>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs text-admin-text-secondary">Início</Label>
              <Input type="time" defaultValue={settings.quietHoursStart} className="mt-1 border-admin-border" variant="light" />
            </div>
            <div>
              <Label className="text-xs text-admin-text-secondary">Fim</Label>
              <Input type="time" defaultValue={settings.quietHoursEnd} className="mt-1 border-admin-border" variant="light" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

